import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const ArrowsUp: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
  width = 0,
  height = 0,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={width || size}
      height={height || size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00171 4.57359L8.00092 4.5728L3 9.57372L4.42629 11L8.00171 7.42458L11.5737 10.9966L13 9.5703L8.0025 4.5728L8.00171 4.57359Z"
        fill={color}
      />
    </svg>
  );
};

export default ArrowsUp;
